export default () => ({
    // TODO: Implementar estado del módulo impact-cases
})
